import Hero from "./Hero";
import TrustStrip from "./TrustStrip";
import CpiSection from "./CpiSection";
import SampleAnalysisSection from "./SampleAnalysisSection";
import HowItWorksSimple from "./HowItWorksSimple";
import TwoPathways from "./TwoPathways";
import Programs from "./Programs";
import UnifiedModel from "./UnifiedModel";
import LongitudinalSection from "./LongitudinalSection";
import TechCards from "./TechCards";
import FounderShort from "./FounderShort";
import UpdatesSection from "./UpdatesSection";
import TeamCompact from "./TeamCompact";
import MediaPartner from "./MediaPartner";
import EcosystemStrip from "./EcosystemStrip";
import EcosystemApps from "./EcosystemApps";
import TalkToRheaPill from "./_partials/TalkToRheaPill";
import FinalCTA from "./FinalCTA";

export default function LandingSections() {
  return (
    <main>
      <Hero />
      <TrustStrip />
      <CpiSection />
      <SampleAnalysisSection />
      <HowItWorksSimple />
      <TwoPathways />
      <Programs />
      <UnifiedModel />
      <LongitudinalSection />
      <TechCards />
      <FounderShort />
      <UpdatesSection />
      <TeamCompact />
      <MediaPartner />
      <EcosystemStrip />
      <EcosystemApps />
      <TalkToRheaPill />
      <FinalCTA />
    </main>
  );
}